const BASE = '/ops-api';

const tokenDe = user => user?.access_token || user?.accessToken || '';

const chamar = async (method, path, user, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      api_access_token: tokenDe(user),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(
      data.error || data.erro || data.mensagem || data.message || `HTTP ${res.status}`
    );
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
};

const accPath = (accountId, rest) => `/accounts/${accountId}/crm${rest}`;

export const apiCrmPipelines = (accountId, user) =>
  chamar('GET', accPath(accountId, '/pipelines'), user);

export const apiCrmBoard = (accountId, user, pipelineId, opts = {}) => {
  const p = new URLSearchParams();
  if (pipelineId) p.set('pipelineId', pipelineId);
  p.set('limit', String(opts.limit ?? 40));
  if (opts.offset != null && opts.offset !== '') p.set('offset', String(opts.offset));
  if (opts.q) p.set('q', opts.q);
  if (opts.colunaId) p.set('colunaId', opts.colunaId);
  const qs = p.toString();
  return chamar('GET', accPath(accountId, `/board${qs ? `?${qs}` : ''}`), user);
};

export const apiCrmBuscarPlataforma = (accountId, user, q) =>
  chamar(
    'GET',
    accPath(accountId, `/buscar-plataforma?q=${encodeURIComponent(q || '')}`),
    user
  );

export const apiCrmColunaCreate = (accountId, user, body) =>
  chamar('POST', accPath(accountId, '/colunas'), user, body);

export const apiCrmColunaPatch = (accountId, user, id, body) =>
  chamar('PATCH', accPath(accountId, `/colunas/${encodeURIComponent(id)}`), user, body);

export const apiCrmColunaDelete = (accountId, user, id, moverParaId) =>
  chamar('DELETE', accPath(accountId, `/colunas/${encodeURIComponent(id)}`), user, {
    moverParaId,
  });

export const apiCrmColunaReorder = (accountId, user, origemId, destinoId) =>
  chamar('POST', accPath(accountId, '/colunas/reordenar'), user, {
    origemId,
    destinoId,
  });

export const apiCrmContatoCreate = (accountId, user, body) =>
  chamar('POST', accPath(accountId, '/contatos'), user, body);

export const apiCrmContatoGet = (accountId, user, id) =>
  chamar('GET', accPath(accountId, `/contatos/${encodeURIComponent(id)}`), user);

export const apiCrmContatoPatch = (accountId, user, id, body) =>
  chamar('PATCH', accPath(accountId, `/contatos/${encodeURIComponent(id)}`), user, body);

export const apiCrmContatoDelete = (accountId, user, id) =>
  chamar('DELETE', accPath(accountId, `/contatos/${encodeURIComponent(id)}`), user);

export const apiCrmContatoMover = (accountId, user, id, colunaId) =>
  chamar('POST', accPath(accountId, `/contatos/${encodeURIComponent(id)}/mover`), user, {
    colunaId,
  });

export const apiCrmPipelineCreate = (accountId, user, nome) =>
  chamar('POST', accPath(accountId, '/pipelines'), user, { nome });

export const apiCrmPipelinePatch = (accountId, user, id, body) =>
  chamar('PATCH', accPath(accountId, `/pipelines/${encodeURIComponent(id)}`), user, body);

export const apiCrmPipelineDelete = (accountId, user, id, moverParaId) =>
  chamar('DELETE', accPath(accountId, `/pipelines/${encodeURIComponent(id)}`), user, {
    moverParaId,
  });

export const apiCrmTags = (accountId, user) =>
  chamar('GET', accPath(accountId, '/tags'), user);

export const apiCrmTagCreate = (accountId, user, nome) =>
  chamar('POST', accPath(accountId, '/tags'), user, { nome });

export const apiCrmCampos = (accountId, user) =>
  chamar('GET', accPath(accountId, '/campos'), user);

export const apiCrmUsuarios = (accountId, user) =>
  chamar('GET', accPath(accountId, '/usuarios'), user);

/** Agenda apagar em lote no ops-179 (server-side). Refresh não cancela. */
export const apiCrmContatoDeleteMany = (accountId, user, ids) => {
  const list = Array.isArray(ids) ? ids.filter(Boolean) : [];
  return chamar('POST', accPath(accountId, '/contatos/apagar-lote'), user, {
    ids: list,
    apagarChatwoot: false, // histórico/contatos Chatwoot preservados
  });
};

export const apiCrmJob = (accountId, user, jobId) =>
  chamar('GET', accPath(accountId, `/jobs/${encodeURIComponent(jobId)}`), user);
